module.exports = __webpack_public_path__ + "img/unelmakone-karta-sv-mobile.5a2ceb04.jpg";